import { canMeasure } from '@/lib/privacy';
import { base44 } from '@/api/base44Client';

const memory = new Map();
const pending = new Map();
const keyFor = (type, id) => `tda-write-cap:${type}:${id}`;
export function getTrackingToken(type, id) {
  if (!id) return undefined;
  const key = keyFor(type, id);
  try { return memory.get(key) || sessionStorage.getItem(key) || undefined; }
  catch { return memory.get(key); }
}
function remember(type, id, token) {
  if (!id || !token) return;
  const key = keyFor(type, id); memory.set(key, token);
  try { sessionStorage.setItem(key, token); } catch { /* memory still works */ }
}
export function trackEvent(type, payload) {
  if (!canMeasure()) return Promise.resolve(null);
  const id = type === 'interest' ? payload.session_id : payload.id;
  const key = keyFor(type, id || 'new');
  // An A/B conversion must prove it belongs to an impression this browser saw.
  const abKeyOf = (p) => (p?.test_id ? `${p.test_id}:${p.variant_id}` : undefined);
  const send = async () => {
    try {
      if (!canMeasure()) return null;
      const abKey = type === 'abtest' ? abKeyOf(payload) : undefined;
      const writeToken = getTrackingToken(type, id) || (abKey ? getTrackingToken('abtest', abKey) : undefined);
      const response = await base44.functions.invoke('trackEvent', {
        type, payload: { ...payload, write_token: writeToken },
      });
      const data = response?.data ?? response;
      remember(type, type === 'interest' ? payload.session_id : data?.id, data?.write_token);
      if (abKey && payload.event_type === 'impression') remember('abtest', abKey, data?.write_token);
      return data;
    } catch { return null; }
  };
  const next = (pending.get(key) || Promise.resolve()).then(send);
  pending.set(key, next);
  next.finally(() => { if (pending.get(key) === next) pending.delete(key); });
  return next;
}
export default trackEvent;